import { Routes, Route } from 'react-router-dom'
import WorkList from './components/admin/WorkList';

import Admin from './pages/Admin';
import About from './pages/admin/About';
import EditWork from './pages/admin/EditWork';
import Filter from './components/home/Filter';
import Forgot from './pages/Forgot';
import Home from './pages/Home';

import Portalofio from './pages/admin/Portafolio';
import Work from './pages/admin/Work';
import _About from './pages/Home/_Abaout';
import _Portalofio from './pages/Home/_Portafolio';
import SingleWork from './components/home/Work';

import { useState } from 'react';
import Labs from './pages/admin/Labs';
import LabsList from './pages/admin/LabList';
import Lab from './pages/admin/Lab';
import _Lab from './components/home/_Lab';
import ListLabs from './components/home/ListLabs';
import SingleLab from './components/home/SingleLab';
import Contacto from './pages/Home/Contacto';


const App = () => {

  const [open, setOpen] = useState(false);

  return (
    <Routes>
      <Route path="/" element={<Home />} >
        <Route index element={<_About open={open} setOpen={setOpen} />} />
        <Route path="portafolio" element={<_Portalofio />}>
          <Route index element={<Filter open={open} setOpen={setOpen} />} />
          <Route path=":id" element={<SingleWork open={open} setOpen={setOpen} />} />
        </Route>
        <Route path="lab" element={<_Lab open={open} setOpen={setOpen} />}>
          <Route index element={<ListLabs />} />
          <Route path=":id" element={<SingleLab />} />
        </Route>
        <Route path="contact" element={<Contacto open={open} setOpen={setOpen} />} />
      </Route>
      <Route path='admin' element={<Admin />}>
        <Route index element={<div>dash</div>} />
        <Route path='lab' element={<Labs />} >
          <Route index element={<LabsList />} />
          <Route path=':id' element={<Lab />} />
          <Route path='new' element={<Lab />} />
        </Route>
        <Route path='about' element={<About />} />
        <Route path='portafolio' element={<Portalofio />} >
          <Route index element={<WorkList />} />
          <Route path=':id' element={<Work />} />
          <Route path='edit/:id' element={<EditWork />} />
          <Route path='new' element={<EditWork />} />
        </Route>
        <Route path='contact' element={<div>Contacto</div>} />
      </Route>
      <Route index path="/forgot" element={<Forgot />} />
    </Routes>

  )
}

export default App;
